import { Component, OnInit, OnDestroy } from '@angular/core';
import { PathWaypointDoc, PathWaypointService } from '../../core/services';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core/app-state';
import { Subscription } from 'rxjs';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { RxdbWaypointsEditComponent } from '../rxdb-waypoints-edit/rxdb-waypoints-edit.component';

@Component({
  selector: 'app-rxdb-waypoints-view',
  templateUrl: './rxdb-waypoints-view.component.html',
  styleUrls: ['./rxdb-waypoints-view.component.css']
})
export class RxdbWaypointsViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  isLoading : boolean = false;
  errorMsg: string = "";
  bSyncing: boolean = false;

  constructor(appState: AppState,
    private waypointService : PathWaypointService,
    private modalService: BsModalService,
    private router: Router ) {
    super(appState)
  }

  ngOnInit(): void {
    this.waypointService.doWhenReady( () => this.loadWaypoints() )
  }

  ngOnDestroy(): void {
    this.destroy()
    this.waypointsSubscription?.unsubscribe()
  }

  rxWaypoints : PathWaypointDoc[] = []
  waypointsSubscription: Subscription

  async loadWaypoints() {
    this.errorMsg = ""
    this.rxWaypoints = []

    this.isLoading = true
    try {
      const waypointsSubject =this.waypointService.rxCollection.find().$;
      this.waypointsSubscription?.unsubscribe();
      this.waypointsSubscription = waypointsSubject.subscribe( (points)=>{
        this.rxWaypoints= points
        this.isLoading=false;
      });
    } catch ( error ) {
      this.errorMsg = this.waypointService.extractErrorMsg(error)
    }
  }

  async clearWaypoints() {
    let initialState = {
      onYes: async () => {
        await this.waypointService.rxCollection.remove().then(async () => {
          console.log('rxCollection remove()')
        }).catch(error => {
          console.log('clearWaypoints() Error: ', error)
        }).finally(() => {
          // location.reload()
          this.router.navigate(['']).then(() => {
            location.reload();
          });
        })
      },
      title: "RxDB Waypoints Rebuild",
      question: `Do you wish to rebuild Waypoint Database?  `
        + `<div class="m-2 small font-italic text-warning"><i class='text-warning fa fa-info-circle mr-1'></i>It may take a few minutes to re-sync Waypoint Data</div>`
        + `<div>Rebuild now?</div>`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.show(ConfirmModalComponent, {ignoreBackdropClick: true,initialState} );
  }

  editWayPoints(pathWaypointDoc: PathWaypointDoc) {
    const initialState = {
      pathWayPoint: pathWaypointDoc
    }
    this.modalService.show(RxdbWaypointsEditComponent, {ignoreBackdropClick: true, initialState});
  }

}
